module.exports = __webpack_public_path__ + "img/Doelen.7c6c9864.png";